<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_iii"></a><strong>SWIMMING IN THE VOLCANO</strong></h1>
<p class="center-t"><strong>A NOVEL</strong></p>
<p class="author"><strong>Bob Shacochis</strong></p>
<p class="pub"><img alt="Image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?52d20ee2